import { DataTable } from "primereact/datatable";
import { ApiTechnicalSupportData } from "../models/technicalSupport.model";
import { Column } from "primereact/column";

interface Props {
  technicalSupportData: ApiTechnicalSupportData[];
}

const tableStyles = `
  .support-table-wrapper {
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    overflow: hidden;
  }

  .support-table-wrapper .p-datatable {
    background: #ffffff !important;
  }

  /* Cabecera limpia en gris claro */
  .support-table-wrapper .p-datatable .p-datatable-thead > tr > th {
    background: #f8fafc !important;
    color: #64748b !important;
    border-bottom: 2px solid #e2e8f0 !important;
    font-weight: 700 !important;
    text-transform: uppercase;
    font-size: 0.75rem;
    letter-spacing: 0.5px;
    padding: 14px 16px !important;
  }

  /* Filas de la tabla */
  .support-table-wrapper .p-datatable .p-datatable-tbody > tr {
    background: #ffffff !important;
    color: #334155 !important;
    transition: background-color 0.15s;
  }

  /* Efecto hover con acento de marca verde */
  .support-table-wrapper .p-datatable .p-datatable-tbody > tr:hover {
    background: #f0fdf4 !important;
  }

  .support-table-wrapper .p-datatable .p-datatable-tbody > tr > td {
    border-bottom: 1px solid #f1f5f9 !important;
    padding: 14px 16px !important;
    font-size: 0.85rem;
  }
`;

function TableTechnicalSupport({ technicalSupportData }: Props) {
  return (
    <>
      <style>{tableStyles}</style>
      <div className="support-table-wrapper">
        <DataTable value={technicalSupportData} tableStyle={{ minWidth: "50rem" }}>
          <Column field="idTechnicalSupport" header="ID" style={{ width: '80px' }} />
          <Column field="description" header="Solicitud" />
          <Column field="dateApplication" header="Fecha reporte" />
          <Column field="descriptionResult" header="Respuesta" />
          <Column field="dateResult" header="Fecha respuesta" />
        </DataTable>
      </div>
    </>
  );
}

export default TableTechnicalSupport;